var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useRef, useState } from "react";
import { useTable, useSortBy, usePagination, useColumnOrder, useBlockLayout, useExpanded, } from "react-table";
import { useSticky } from "react-table-sticky";
import { tableColumns, tableData } from "../model/FTLTableModel";
import { FTLLoader, FTLTypography, useComponentDimensions } from "../../../..";
import React from "react";
import clsx from "clsx";
import FTLTableStyles from "../styles/FTLTableStyles.styles";
import { Box, useTheme } from "@material-ui/core";
import FTLTableFooter from "./FTLTableFooter";
import RowComponents from "./subComponents/RowComponents";
import FTLTableBody from "./FTLTableBody";
import HeaderComponents from "./subComponents/HeaderComponents";
export default (_a) => {
    var { showHeader = true, showFooter = true, noCellBorder = false, columns, data, isFetching, hasData = Boolean(data === null || data === void 0 ? void 0 : data.length), isSearching, pageCount = 0, rowHeight = 40, noDataMessage = (React.createElement(FTLTypography, { variant: "h2", color: "secondary" }, "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445 \u0434\u043B\u044F \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F")), noFilteredDataMessage = (React.createElement(FTLTypography, { variant: "h2", color: "secondary" }, "\u041F\u043E\u0438\u0441\u043A \u043D\u0435 \u0434\u0430\u043B \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432")), rowDisable, onRowClick, tableState, actionsSize = 1, actionAccessor = "action", setTableState, rowProps, classes: classesFromProps, actionComponent: ActionComponent, sectionHeaderCounterData, sectionHeaderActionButtons, sectionHeaderTitleAccessor, isRowsInitialExpanded = false } = _a, otherProps = __rest(_a, ["showHeader", "showFooter", "noCellBorder", "columns", "data", "isFetching", "hasData", "isSearching", "pageCount", "rowHeight", "noDataMessage", "noFilteredDataMessage", "rowDisable", "onRowClick", "tableState", "actionsSize", "actionAccessor", "setTableState", "rowProps", "classes", "actionComponent", "sectionHeaderCounterData", "sectionHeaderActionButtons", "sectionHeaderTitleAccessor", "isRowsInitialExpanded"]);
    const [showFirstColumnShadow, setShowFirstColumnShadow] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [actionComponentWidth, setActionComponentWidth] = useState(0);
    const tableRef = useRef(null);
    const { clientWidth: tableWidth } = useComponentDimensions(tableRef);
    const classes = FTLTableStyles({
        showFooter,
        onRowClick,
        hasData,
        isFetching,
    });
    const theme = useTheme();
    useEffect(() => {
        if (isRowsInitialExpanded)
            toggleAllRowsExpanded();
    }, [isRowsInitialExpanded]);
    useEffect(() => {
        if (hasData && !isFetching)
            setIsLoading(false);
    }, [hasData, isFetching]);
    useEffect(() => {
        if ((tableState === null || tableState === void 0 ? void 0 : tableState.columnOrder) && tableState.columnOrder !== state.columnOrder)
            setColumnOrder(tableState.columnOrder);
    }, [tableState === null || tableState === void 0 ? void 0 : tableState.columnOrder]);
    useEffect(() => {
        if ((tableState === null || tableState === void 0 ? void 0 : tableState.hiddenColumns) &&
            tableState.hiddenColumns !== state.hiddenColumns)
            setHiddenColumns(tableState.hiddenColumns);
    }, [tableState === null || tableState === void 0 ? void 0 : tableState.hiddenColumns]);
    const { getTableProps, getTableBodyProps, prepareRow, setColumnOrder, setHiddenColumns, toggleAllRowsExpanded, rows, headerGroups, state, } = useTable({
        autoResetPage: true,
        columns: tableColumns({
            isFetching,
            hasData,
            columns,
            actionsSize,
            actionAccessor,
        }),
        data: tableData({ hasData, tableState, data }),
        defaultCanSort: false,
        disableMultiSort: false,
        manualPagination: true,
        pageCount,
        initialState: {
            pageSize: tableState === null || tableState === void 0 ? void 0 : tableState.pageSize,
            pageIndex: tableState === null || tableState === void 0 ? void 0 : tableState.pageIndex,
            hiddenColumns: (tableState === null || tableState === void 0 ? void 0 : tableState.hiddenColumns) || [],
            columnOrder: tableState === null || tableState === void 0 ? void 0 : tableState.columnOrder,
        },
    }, useSortBy, useExpanded, usePagination, useColumnOrder, useBlockLayout, useSticky);
    const columnsScrollHandler = (obj) => {
        if (obj.scrollLeft === 0)
            setShowFirstColumnShadow(false);
        else
            setShowFirstColumnShadow(true);
    };
    if (hasData || isFetching) {
        return (React.createElement(Box, Object.assign({ className: classes.root, position: "relative" }, otherProps, { height: "100%" }),
            isFetching && hasData && (React.createElement(FTLLoader, { alignItems: "center", justifyContent: "center", height: showFooter ? "calc(100% - 80px)" : "100%", width: "100%", position: "absolute", zIndex: theme.zIndex.tooltip - 1 })),
            React.createElement("div", { className: clsx(classes.overflowTableWrapper, showFirstColumnShadow && classes.showFirstColumnShadow), ref: tableRef, onScroll: (e) => {
                    columnsScrollHandler(e.currentTarget);
                } },
                React.createElement("table", Object.assign({}, getTableProps(), { className: clsx(classes.table, classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.table) }),
                    React.createElement(HeaderComponents, { actionComponentWidth: actionComponentWidth, showHeader: showHeader, headerGroups: headerGroups, tableState: tableState, setTableState: setTableState, classes: classesFromProps }),
                    React.createElement(FTLTableBody, Object.assign({}, getTableBodyProps(), { showHeader: showHeader, style: isFetching && hasData ? { opacity: 0.5 } : {}, className: classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.tableBody }),
                        React.createElement(RowComponents, { setActionComponentWidth: setActionComponentWidth, sectionHeaderActionButtons: sectionHeaderActionButtons, tableOffsetWidth: tableWidth, rows: rows, sectionHeaderCounterData: sectionHeaderCounterData, sectionHeaderTitleAccessor: sectionHeaderTitleAccessor, actionComponent: ActionComponent, rowHeight: rowHeight, prepareRow: prepareRow, rowDisable: rowDisable, onRowClick: onRowClick, noCellBorder: noCellBorder, rowProps: rowProps, isFetching: isFetching, hasData: hasData, classes: classesFromProps })))),
            !isLoading && showFooter && tableState && (React.createElement(FTLTableFooter, { disabled: isFetching, pageIndex: tableState.pageIndex, pageSize: tableState.pageSize, pageCount: pageCount, setPageSize: (pageSize) => setTableState && setTableState({ pageSize }), gotoPage: (pageNumber) => {
                    setTableState && setTableState({ pageIndex: pageNumber - 1 });
                }, className: classesFromProps === null || classesFromProps === void 0 ? void 0 : classesFromProps.footer }))));
    }
    else {
        return (React.createElement("div", { className: classes.noDataMessage }, isSearching && !hasData ? noFilteredDataMessage : noDataMessage));
    }
};
//# sourceMappingURL=FTLTable.js.map